import { View, Text as PDFText } from '@react-pdf/renderer'

import { Policies } from '../../../../../types/bookingDetails'
import styles from './styles/index.styles'

interface CancelTermsAndConditionsProps {
  cancelPolicies: Policies[]
  cancelPolicyDescription: string[]
  splitTextByWords(inputString: string, maxLength: number): string[]
}
export const CancelTermsAndConditions = ({
  cancelPolicies,
  cancelPolicyDescription,
  splitTextByWords
}: CancelTermsAndConditionsProps) => {
  const hasShortPolicy = cancelPolicies.some((ele) => ele.deadline <= 4320)

  const hasValidDescription =
    cancelPolicyDescription.length > 0 &&
    cancelPolicyDescription.some(
      (d) => d.trim().length > 3 && !d.includes('\n')
    )

  if (!hasValidDescription && !hasShortPolicy) return <View />

  return (
    <View style={styles.mainDiv} wrap>
      <View style={styles.titleContainer}>
        <PDFText style={styles.mainTitle}>شرایط و مقررات کنسلی</PDFText>
      </View>
      <View style={styles.content}>
        {hasValidDescription
          ? cancelPolicyDescription.map((item, index) => {
              const segments =
                item.includes('\n') || true
                  ? [item]
                  : splitTextByWords(item, 130)
              return segments.map((segment, segIndex) => (
                <View
                  key={`${index}-${segIndex}`}
                  style={
                    segIndex === 0
                      ? styles.singleParagraph
                      : styles.singleParagraphShort
                  }>
                  <View style={styles.title}>
                    <PDFText>
                      {/* {segment.replace(/\(|\)/g, ($1) =>
                        $1 === ')' ? '(' : ')'
                      )} */}
                      {segment}
                    </PDFText>
                  </View>
                </View>
              ))
            })
          : cancelPolicies.map((item, index) => {
              switch (item.policyType) {
                case 'ReservationTime':
                case 'CheckInTime':
                case 'AfterCheckInTime':
                case 'BeforeCheckOutTime':
                  if (item.deadline > 4320) return <View key={index} />
                  return (
                    <View key={index} style={styles.singleParagraph}>
                      <View style={styles.title}>
                        <PDFText>
                          {item.deadline % 24 === 0
                            ? Math.floor(item.deadline / 24)
                            : item.deadline}{' '}
                        </PDFText>
                        <PDFText>
                          {item.deadline % 24 === 0 ? 'روز' : 'ساعت'}{' '}
                        </PDFText>
                        <PDFText>
                          {item.policyType === 'AfterCheckInTime' ||
                          item.policyType === 'ReservationTime'
                            ? ' :بعد از زمان رزرو '
                            : item.policyType === 'CheckInTime'
                            ? ' :قبل از زمان ورود '
                            : ' :قبل از زمان خروج '}
                        </PDFText>
                      </View>
                      <View style={styles.description}>
                        <PDFText>{item.penaltyAmount}% </PDFText>
                        <PDFText> از</PDFText>
                        <PDFText>
                          {item.penaltyType === 'FirstNight'
                            ? ' هزینه شب اول'
                            : ' قیمت کل '}
                        </PDFText>
                        <PDFText>.به عنوان جریمه کسر خواهد شد</PDFText>
                      </View>
                    </View>
                  )
                default:
                  return <View key={index} />
              }
            })}
      </View>
    </View>
  )
}
